/**
 * Sidedish aka addition. It can and it should be extended from a general product entity.
 * @author Ka Wing Chin
 * @class Takeaway.SideDish
 */

export default class SideDish {
  constructor (obj) {
    if (obj !== undefined) {
      for (let prop in obj) {
        this[prop] = obj[prop]
      }
    }
  }

  id
  sideDishName
  price = 0
  pricePickup = 0
  ignoreMinimumOrderValue = false
}
